import * as actions from './actionsTypes';

const initialData = {
  loader: false,
}

export default function updateDependantsDataReducer(state = initialData, action){
  switch (action.type) {
    case actions.REQUEST_CHANGES_DEPENDANTS_LOADER_DATA:
      return {...state, loader: action.payload}
    default:
      return state
  }
}